if (window.location.href.indexOf("gift-earrings") > -1){
    window.location.replace("https://mayamarjewelry.com/collections/earrings-v2/products/ella-huggies");
};

if (window.location.href.indexOf("pearl-charm-necklace") > -1){
    window.location.replace("https://mayamarjewelry.com");
};

if (window.location.href.indexOf("package-protection") > -1){
    window.location.replace("https://mayamarjewelry.com");
};

if (window.location.href.indexOf("gift-travel-case") > -1){
    window.location.replace("https://mayamarjewelry.com/products/travel-case");
};

if (window.location.href.indexOf("gift-cap") > -1){
    window.location.replace("https://mayamarjewelry.com/products/mayamar-cap");
};

/*
if (window.location.href.indexOf("cleaning-kit") > -1){
    window.location.replace("https://mayamarjewelry.com");
};*/


function $cartReady(){
  $('div#rebuy-cart .rebuy-cart__flyout-recommendations').prepend('<div data-rebuy-id="194472"></div>');
};

document.addEventListener('rebuy.ready', function(event){
  let idWidget = event.detail.widget.id;
  if(idWidget === '194472'){
    let containerTitle = $('div#rebuy-widget-194472 .rebuy-widget-content');
    let titleWidget = $('div#rebuy-widget-194472 .rebuy-widget-content h3.super-title');
    containerTitle.before(titleWidget);
  }
});




function notesGift(){
  var $input = $('#rebuy-cart .rebuy-cart__flyout-note .rebuy-cart__flyout-note-toggle .rebuy-cart__flyout-note-toggle-input');
  var $label = $('#rebuy-cart .rebuy-cart__flyout-note .rebuy-cart__flyout-note-toggle .rebuy-cart__flyout-note-toggle-label');
  var $message = '<div class="rebuy-cart__note-message"><p>* Your message will be printed on the receipt but prices are hidden.</p></div>';
  $('#rebuy-cart .rebuy-cart__flyout-note .rebuy-cart__flyout-note-toggle').prepend('<div class="rebuy-cart__note-text"><span>Is This a Gift?</span></div>');
  $('#rebuy-cart .rebuy-cart__flyout-note .rebuy-cart__flyout-note-toggle').append('<div class="rebuy-cart__note-label"></div>');
  $('#rebuy-cart .rebuy-cart__flyout-note .rebuy-cart__flyout-note-toggle').append($($message));
  $( "#rebuy-cart .rebuy-cart__flyout-note-toggle .rebuy-cart__note-label" ).append($($input),$($label));
};


function $renderContainer(){
  $(".rebuy-cart__flyout-body .rebuy-cart__flyout-content").prepend(

    '<div class="container-progress-bar">' +
    
        '<h3 class="progress-bar__title">Gift Cap and Free Shipping on all orders</h3>'+
        
        '<section class="progress-bar-cart">'+

            '<div class="progress-bar-cart__container">'+
        		'<div id="progress-bar__gift-necklace" class="progress-bar-cart__bar"></div>'+
        	'</div>'+
        
        	'<div class="progress-bar__icon">'+
        		'<div id="container-icon__gift-necklace" class="progress-bar__icon-container">'+
        			'<i id="icon__gift-necklace" class="fas fa-lock"></i>'+
        		'</div>'+
        		'<p class="progress-bar__icon-text">Gift Cap</p>'+
        	'</div>'+

        	'<div class="progress-bar-cart__container">'+
        		'<div id="progress-bar__free-shipping" class="progress-bar-cart__bar"></div>'+
        	'</div>'+
        
        	'<div class="progress-bar__icon">'+
        		'<div id="container-icon__free-shipping" class="progress-bar__icon-container">'+
        			'<i id="icon__free-shipping" class="fas fa-lock"></i>'+
        		'</div>'+
        		'<p class="progress-bar__icon-text">Free Shipping</p>'+
        	'</div>'+
        
        	'<div class="progress-bar-cart__container">'+
        		'<div id="progress-bar__5-off" class="progress-bar-cart__bar"></div>'+
        	'</div>'+
        
        	'<div class="progress-bar__icon">'+
        		'<div id="container-icon__5-off" class="progress-bar__icon-container">'+
        			'<i id="icon__5-off" class="fas fa-lock"></i>'+
        		'</div>'+
        		'<p class="progress-bar__icon-text">Gift Travel Case</p>'+
        	'</div>'+
        
        '</section>'+

        '<p class="disclaimer-message">* Cap and Travel Case available while supplies last.</p>' +

    '</div>'
  );
};


function $rebuyPrices(){
  $('.rebuy-cart__flyout-footer .rebuy-cart__flyout-subtotal').append(
    '<div class="rebuy-cart__flyout-subtotal--campaign">' +
      '<span class="offert"></span>' +
      '<span class="regular"></span>' +
    '</div>'
  );
};

function $changePrices(offer,regular){
  var $offer = (offer/100).toFixed(2);
  var $regular = (regular/100).toFixed(2);
  var $showOffer = '$' + $offer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  var $showRegular = '$' + $regular.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  $('.rebuy-cart__flyout-subtotal--campaign .offert').text($showOffer);
  $('.rebuy-cart__flyout-subtotal--campaign .regular').text($showRegular);

  if($offer != $regular){
    $('.rebuy-cart__flyout-subtotal--campaign .offert').addClass('show-price-offert');
    $('.rebuy-cart__flyout-subtotal--campaign .regular').addClass('show-price-offert');
  } else {
    $('.rebuy-cart__flyout-subtotal--campaign .offert').removeClass('show-price-offert');
    $('.rebuy-cart__flyout-subtotal--campaign .regular').removeClass('show-price-offert');
  };
};



function $progress_bar(totalPrice,arrayProducts){

    
    // VAR REBUY

    var $total_price = totalPrice;
    var $array_products = arrayProducts;

    // PRICES

    var $price_promotion_one = 1 - $total_price;
    var $promotion_one = $price_promotion_one /= Math.pow(10, 2);

    var $price_promotion_two = 1 - $total_price;
    var $promotion_two = $price_promotion_two /= Math.pow(10, 2);

    var $price_promotion_three = 15000 - $total_price;
    var $promotion_three = $price_promotion_three /= Math.pow(10, 2);

    

    // PRODUCT OFFER


    function $product_offer(productId) {return productId.product_id === 7004188966961;};var $validation_product = $array_products.find($product_offer);
    function $product_travelCase(productId) {return productId.product_id === 6907979464753;};var $validation_travelCase = $array_products.find($product_travelCase);

    if ($validation_product) {
      if($total_price <= 0){
        jQuery.post('/cart/update.js', {
          updates: {
            40592227663921: 0
          }
        });
      } else if($total_price > 0){
        var qty_necklace = $validation_product.quantity;
        if(qty_necklace > 1){
          jQuery.post('/cart/update.js', {
            updates: {
              40592227663921: 1
            }
          });
        };
      };
    };
  
    if ($validation_travelCase) {
        if ($total_price <= 14999) {
          jQuery.post('/cart/update.js', {
            updates: {
              40326191546417: 0
            }
          });
        } else if ($total_price >= 15000) {
          var qty_travel_case = $validation_travelCase.quantity;
          if(qty_travel_case > 1){
            jQuery.post('/cart/update.js', {
              updates: {
                40326191546417: 1
              }
            });
          };
        };
    };


     // FUNCTION PROGRESS BAR    

    if ($total_price <= 0) {
      $("#progress-bar__gift-necklace,#progress-bar__free-shipping,#progress-bar__5-off").animate({width: "0%",}, 1000);
      $("#icon__gift-necklace").replaceWith('<i id="icon__gift-necklace" class="fas fa-lock"></i>');
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
      $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-lock"></i>');
      $("#container-icon__gift-necklace,#container-icon__free-shipping,#container-icon__5-off").css({"background-color": "white", "border-color": "#000000"});
      $("#icon__gift-necklace,#icon__free-shipping,#icon__5-off").css("color", "#000000");
      $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Gift Cap and Free Shipping on all orders</h3>');
    }  else if ($total_price > 0 && $total_price <= 14999) {

        if ($validation_product === undefined){
          var dataProduct = {
            "id": 40592227663921,
            "quantity": 1
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: dataProduct,
            dataType: 'json',
            success: function() { 
              console.log('Bracelet: Agregado');
            }
          });
        };

        $("#progress-bar__gift-necklace,#progress-bar__free-shipping").animate({width: "100%",}, 1000);
        $("#progress-bar__5-off").animate({width: "0%",}, 1000);
        $("#icon__gift-necklace").replaceWith('<i id="icon__gift-necklace" class="fas fa-check-circle"></i>');
        $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
        $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-lock"></i>');
        $("#container-icon__gift-necklace,#container-icon__free-shipping").css({"background-color": "#000000", "border-color": "#000000"});
        $("#container-icon__5-off").css({"background-color": "white", "border-color": "#000000"});
        $("#icon__gift-necklace,#icon__free-shipping").css("color", "white");
        $("#icon__5-off").css("color", "#000000");
        $(".progress-bar__title").replaceWith(
          '<div class="progress-bar__title">'+
            '<h3>You Unlocked Gift Cap + Free Shipping</h3>'+
            '<h5>You need <b>$' + $promotion_three + '</b> to get gift travel case</h5>'+
          '</div>'
        );
      
    } else if ($total_price >= 15000) {

        if ($validation_product === undefined){
          var dataProduct = {
            "id": 40592227663921,
            "quantity": 1
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: dataProduct,
            dataType: 'json',
            success: function() { 
              console.log('Bracelet: Agregado');
            }
          });
        };


        if ($validation_travelCase === undefined) {
          var dataProductTravel = {
            "id": 40326191546417,
            "quantity": 1
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: dataProductTravel,
            dataType: 'json',
            success: function() { 
              console.log('Travel Case: Agregado');
            }
          });
        };

        $("#progress-bar__gift-necklace,#progress-bar__free-shipping,#progress-bar__5-off").animate({width: "100%",}, 1000);
        $("#icon__gift-necklace").replaceWith('<i id="icon__gift-necklace" class="fas fa-check-circle"></i>');
        $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
        $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-check-circle"></i>');
        $("#container-icon__gift-necklace,#container-icon__free-shipping,#container-icon__5-off").css({"background-color": "#000000", "border-color": "#000000"});
        $("#icon__gift-necklace,#icon__free-shipping,#icon__5-off").css("color", "white");
        $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">You Unlocked Gift Cap + Free Shipping + Gift Travel Case</h3>');
      
    };

};



/* Script Buy X Save Y */

function $buyXsaveY(qty){

    
    // VAR REBUY
    var $quantity = qty;


    // FUNCTION PROGRESS BAR
    if ($quantity <= 0){
      $("#progress-bar__free-shipping,#progress-bar__5-off").animate({width: "0%",}, 1000);
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
      $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-lock"></i>');
      $("#container-icon__free-shipping,#container-icon__5-off").css({"background-color": "white", "border-color": "#000000"});
      $("#icon__free-shipping,#icon__5-off").css("color", "#000000");
      $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Free shipping on all orders</h3>');
    } else if ($quantity == 1){
      $("#progress-bar__free-shipping").animate({width: "100%",}, 1000);
      $("#progress-bar__5-off").animate({width: "35%",}, 1000);
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-truck"></i>');
      $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-lock"></i>');
      $("#container-icon__free-shipping").css({"background-color": "#000000", "border-color": "#000000"});
      $("#container-icon__5-off").css({"background-color": "white", "border-color": "#000000"});      
      $("#icon__free-shipping").css("color", "white");
      $("#icon__5-off").css("color", "#000000");
      $(".progress-bar__title").replaceWith(
        '<div class="progress-bar__title">'+
          '<h3>You Unlocked Free Shipping</h3>'+
          "<h5>Don't miss out on a free third item: <b>Add 2 items more now!</b></h5>"+
        '</div>'
      );
    } else if ($quantity == 2){
      $("#progress-bar__free-shipping").animate({width: "100%",}, 1000);
      $("#progress-bar__5-off").animate({width: "70%",}, 1000);
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-truck"></i>');
      $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-lock"></i>');
      $("#container-icon__free-shipping").css({"background-color": "#000000", "border-color": "#000000"});
      $("#container-icon__5-off").css({"background-color": "white", "border-color": "#000000"});
      $("#icon__free-shipping").css("color", "white");
      $("#icon__5-off").css("color", "#000000");
      $(".progress-bar__title").replaceWith(
        '<div class="progress-bar__title">'+
          '<h3>You Unlocked Free Shipping</h3>'+
          "<h5>Don't miss out on a free third item: <b>Add 1 items more now!</b></h5>"+
        '</div>'
      );
    } else if ($quantity >= 3){
      $("#progress-bar__free-shipping,#progress-bar__5-off").animate({width: "100%",}, 1000);
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-truck"></i>');
      $("#icon__5-off").replaceWith('<i id="icon__5-off" class="fas fa-check-circle"></i>');
      $("#container-icon__free-shipping,#container-icon__5-off").css({"background-color": "#000000", "border-color": "#000000"});
      $("#icon__free-shipping,#icon__5-off").css("color", "white");
      $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Success! BUY 2 GET 1 FREE applied to your order</h3>');
    };

};

var $qtyOffer;

function $qtymessage(qty){
  
  var $quantity = qty;
  var $base = 3;
  var $result = $base - $quantity;

  if ($result <= 0) {
    $('.message-offer-buy-more > span').text("Success! BUY 2 GET 1 FREE applied to your order.");
  } else if ($result == 1) {
    $('.message-offer-buy-more > span').text("Don't miss out on a free third item: Add 1 item more now!");
  } else if ($result == 2) {
    $('.message-offer-buy-more > span').text("Don't miss out on a free third item: Add 2 items more now!");
  } else if ($result == 3) {
    $('.message-offer-buy-more > span').text("Add any 3 items to the cart, get 1 of them for free.");
  };
  
};



/* Script Insurance */

function $renderInsurance(){
  $('.rebuy-cart__flyout-apps').prepend( 
    '<section class="insurance-personalized">' +
        '<div class="insurance-personalized__container">' +
            '<div class="logo">' +
                '<svg version="1.1" id="icon-svg-insure" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 185 200" style="enable-background:new 0 0 185 200;" xml:space="preserve"><g><path class="st0" d="M92.4,200c-30.7-13.9-86.2-56.3-87.4-88.9L1.8,26.6C1.8,26.6,44.1,0,92.4,0s90.9,26.6,90.9,26.6l-3.4,84.5C178.6,143.7,123.3,186.1,92.4,200z M16.6,34.4l2.9,76.2c1,25.3,49.7,60.9,72.8,73.3V14.4c-19,0-38.2,4.6-55.8,11.2C30,28.3,23,31.2,16.6,34.4z M92.4,190.7c26.3-12.9,78.2-51.4,79.2-79.9l3.2-79.7C151.3,17.5,118.4,8.3,92.4,8.3c-19.7,0-39.7,4.6-58,11.7c-6.8,2.4-17.1,6.6-24.1,11l2.9,79.9C14.4,139.3,66.1,177.8,92.4,190.7z"/></g></svg>' +
            '</div>' +
            '<div class="message">' +
                '<h5>Package Protection</h5>' +
                '<p>Coverage for loss, theft, or transit damage, with added free return benefits.</p>' +
            '</div>' +
            '<div class="button-price">' +
                '<label class="switch">' +
                    '<input id="insurange-rebuy" type="checkbox">' +
                    '<span class="slider round"></span>' +
                '</label>' +
                '<p class="price">$5.00</p>' +
            '</div>' +
        '</div>' +
    '</section>'
  );
};

function $insurance(totalPrice,arrayProducts){
  
   var $total_price = totalPrice;
   var $array_products = arrayProducts;

    function $findInsurange(id) {
      return id.product_id === 6838551281713;
    };

    var $protectPackage = $array_products.find($findInsurange);

    if($protectPackage === undefined){

      if ($total_price > 500) {

        var currentDate = new Date().toDateString();
        var cookieName = 'insurangeAdd_' + currentDate;
        console.log(cookieName);
      
        if (document.cookie.indexOf(cookieName) === -1) {
          var data = {
            "id": 40133863604273,
            "quantity": 1
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() { 
              $('#insurange-rebuy').prop('checked', true);
            }
          });
          
          var expireDate = new Date();
          expireDate.setDate(expireDate.getDate() + 1);
          document.cookie = cookieName + '=1; expires=' + expireDate.toUTCString() + '; path=/';
          
        } else {

          $('#insurange-rebuy').prop('checked', false);
          
        };
        
      } else {

        $('#insurange-rebuy').prop('checked', false);
        
      };

    } else {
      
      if ($total_price > 500) {

        var $qty_product = $protectPackage.quantity;

        if($qty_product > 1){
          jQuery.post('/cart/update.js', {
            updates: {
              40133863604273: 1
            }
          });
        };
        $('#insurange-rebuy').prop('checked', true);
        
      } else {
        
        $('#insurange-rebuy').prop('checked', false);
        jQuery.post('/cart/update.js', {
          updates: {
            40133863604273: 0
          }
        });
      };
      
    };

};

$(document).on('change', '#insurange-rebuy', function() {
  
  if ($(this).is(':checked')){
     var data = {
      "id": 40133863604273,
      "quantity": 1
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        console.log('Add Protect Package');
      }
    });
  } else {
    jQuery.post('/cart/update.js', {
      updates: {
        40133863604273: 0
      }
    });
  };
});





/* Script Events Rebuy */

document.addEventListener('rebuy:smartcart.ready', function(event){
  console.log('rebuy:smartcart.ready event', event.detail);
  var $total_price = event.detail.smartcart.cart.items_subtotal_price;
  var $total_discount = event.detail.smartcart.cart.total_price;
  var $array_products = event.detail.smartcart.cart.items;
  var $quantity = event.detail.smartcart.cart.item_count;

  var $container_notes = $('#rebuy-cart .rebuy-cart__flyout-note .rebuy-cart__flyout-note-toggle');
  if (!$container_notes.length) {
    setTimeout(notesGift, 300);
  }; 

  $qtyOffer = event.detail.smartcart.cart.item_count;
  $qtymessage($qtyOffer);

  $renderInsurance();
  $insurance($total_discount,$array_products);


  $cartReady();
  
  // $renderContainer();
  $rebuyPrices();
  $changePrices($total_discount,$total_price);

  $renderContainer();
  $progress_bar($total_discount,$array_products);
  //$buyXsaveY($quantity);


  renderGroupSet();
  setTimeout(GroupSet, 1000);
  
});

document.addEventListener('rebuy:cart.change', function(event){
  console.log('rebuy:cart.change event', event.detail);
  var $container = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .container-progress-bar');
  var $containerPrices = $('.rebuy-cart__flyout-footer .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal--campaign');
  var $total_price = event.detail.cart.cart.items_subtotal_price;
  var $total_discount = event.detail.cart.cart.total_price;
  var $array_products = event.detail.cart.cart.items;
  var $quantity = event.detail.cart.cart.item_count;


  if($quantity > 0 ){
    $('header-component#header-component .cart-bubble').removeClass('visually-hidden');
    $('header-component#header-component .header-actions__cart-icon').addClass('header-actions__cart-icon--has-cart');

    if (!($('header-component#header-component .cart-bubble .cart-bubble__text-count').length > 0)) {
      $('header-component#header-component .cart-bubble .cart-bubble__text').append(`
        <span class="cart-bubble__text-count" aria-hidden="true"></span>
      `);
      $('header-component#header-component .cart-bubble .cart-bubble__text-count').text($quantity);
    } else {
      $('header-component#header-component .cart-bubble .cart-bubble__text-count').text($quantity);
    }
    
  } else {
    $('header-component#header-component .cart-bubble').addClass('visually-hidden');
    $('header-component#header-component .header-actions__cart-icon').removeClass('header-actions__cart-icon--has-cart');
    $('header-component#header-component .cart-bubble .cart-bubble__text-count').text($quantity);
  }

  

  var $container_notes = $('#rebuy-cart .rebuy-cart__flyout-note .rebuy-cart__flyout-note-toggle');
  if (!$container_notes.length) {
    setTimeout(notesGift, 300);
  }; 

  $qtyOffer = event.detail.cart.cart.item_count;
  $qtymessage($qtyOffer);

  var $containerInsurance = $('.rebuy-cart__flyout-apps .insurance-personalized');
  if ($containerInsurance.length > 0) {
    $insurance($total_discount,$array_products);
  }; 

  if ($containerPrices.length > 0) {
    $changePrices($total_discount,$total_price);
  };  

  if ($container.length > 0) {
    $progress_bar($total_discount,$array_products);
    //$buyXsaveY($quantity);
  };  


  var $containerSets = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-sets');
  if ($containerSets.length > 0) {
    setTimeout(GroupSet, 1000);
  };


});














/* Script para SETS */

function renderGroupSet(){
  $('.rebuy-cart__flyout-body .container-progress-bar').after('<div class="rebuy-cart__flyout-sets"><h4 id="heading-product-sets">Product Sets:</h4></div><div class="title-simple-products">Individual Products:</div>');
};

function GroupSet(){

  var grupos = {};
  var cantidadElementos = 0;
  var lineItemsBasic = 0;
    
  $("div#rebuy-cart ul.rebuy-cart__flyout-items li.rebuy-cart__flyout-item").each(function() {
  
      var classes = $(this).attr("class").split(" ");
      var idClass = classes.find(function(className) {
          return className.startsWith("property-id-set:"); 
      });
  
      if (idClass) {
          var id = idClass.split(":")[1];
        
          if (!grupos[id]) {
              grupos[id] = [];
          };
          
          grupos[id].push(this);
      } else {
        
        lineItemsBasic++;
        
      };
      
  });

  for (var id in grupos) {
    if($('div#rebuy-cart .rebuy-cart__flyout-sets ul.' + id).length === 0){

      var lista = $("<ul class='" + id + "'></ul>");
      var productsList = $("<ul class='products-set-conform--" + id + "'></ul>");

      var containerSet = $(`
        <div class="container-set-rebuy container-set-rebuy--${id}">
          <div class="rebuy-cart__flyout-item">
            <div class="rebuy-cart__flyout-item-media">
              <a href="/" tabindex="-1">
                <img src>
              </a>
            </div>
            <div class="rebuy-cart__flyout-item-info">
              <a role="heading" aria-level="5" href="/" class="rebuy-cart__flyout-item-product-title">-</a>
              <div class="rebuy-cart__flyout-item-properties">
                <div class="rebuy-cart__flyout-item-property property-key-id-set">
                  <span class="rebuy-cart__flyout-item-property-name">ID SET</span>
                  <span class="rebuy-cart__flyout-item-property-separator">:</span>
                  <span class="rebuy-cart__flyout-item-property-value">${id}</span>
                </div>
              </div>
              <button type="button" class="rebuy-cart__flyout-item-remove">
                <i aria-hidden="true" class="far fa-trash"></i>
              </button>
              <div class="rebuy-cart__flyout-item-quantity">
                <div class="container-button-view-all-products">
                  <span class="view-products button-active">View Products</span>
                </div>
              </div>
              <div class="rebuy-cart__flyout-item-price">
                <div>
                  <span class="rebuy-money"><span>$-</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      `);
      
      var elementosOriginales = grupos[id];

      if (elementosOriginales) {
        var $setPrice = 0;
        elementosOriginales.forEach(function(elementoOriginal) {
            var copiaElemento = $(elementoOriginal).clone();
            lista.append(copiaElemento);

            var priceSetUnit = parseFloat(
              $(elementoOriginal)
                .find('.rebuy-cart__flyout-item-price > div .rebuy-money:first-child > span:last-child')
                .text()
                .replace(/[^0-9.-]+/g, "")
            );

            var qtySet = parseInt(
              $(elementoOriginal)
                .find('.rebuy-cart__flyout-item-quantity-widget-label')
                .contents()
                .filter(function() {
                    return this.nodeType === 3; // TEXT NODE
                })
                .text()
                .trim()
            ) || 1;

            var priceSet = priceSetUnit * qtySet;

            $setPrice += priceSet;

            var $productTitleSet = $(elementoOriginal).find('.rebuy-cart__flyout-item-info > .rebuy-cart__flyout-item-product-title').text();
            productsList.append('<li>' + $productTitleSet + '</li>');
        });

        var $priceSetShow = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format($setPrice);
      };
      
      $('.rebuy-cart__flyout-sets').append(containerSet);
      $('.rebuy-cart__flyout-sets .container-set-rebuy--' + id +'').append(lista);

      var selector = containerSet.find('> .rebuy-cart__flyout-item');
      $(lista).find('li').each(function() {

          if ($(this).hasClass('product-tierra-bangle-set-bangle-1') && $(this).hasClass('property-key-id-set')) {

              var urlChange = 'https://mayamarjewelry.com/products/tierra-bangle-set';
              var nameChange = 'Tierra Bangle Set';
              var imagenChange = 'https://mayamarjewelry.com/cdn/shop/files/MM-01403-1_792e1b2e-2010-4a08-9507-e31add999226_240x240.jpg';

              if(GlobalCampaignActive){
                var priceChange = '$48.00';
              } else {
                var priceChange = '$80.00';
              }

              selector.find('> .rebuy-cart__flyout-item-media img').attr('src', imagenChange);
              selector.find('> .rebuy-cart__flyout-item-media a').attr('href', urlChange);
              selector.find('> .rebuy-cart__flyout-item-info > a').attr('href', urlChange).text(nameChange);
              selector.find('> .rebuy-cart__flyout-item-info .rebuy-money').text(priceChange);

          } else if ($(this).hasClass('product-midnight-mocha-bangle-set-bangle-1') && $(this).hasClass('property-key-id-set')){

              var urlChange = 'https://mayamarjewelry.com/products/midnight-mocha-bangle-set';
              var nameChange = 'Midnight Mocha Bangle Set';
              var imagenChange = 'https://mayamarjewelry.com/cdn/shop/files/MM-01406-1_0628c2ae-3340-4b07-a720-9d0e6671392e_240x240.jpg';

              if(GlobalCampaignActive){
                var priceChange = '$36.00';
              } else {
                var priceChange = '$60.00';
              }

              selector.find('> .rebuy-cart__flyout-item-media img').attr('src', imagenChange);
              selector.find('> .rebuy-cart__flyout-item-media a').attr('href', urlChange);
              selector.find('> .rebuy-cart__flyout-item-info > a').attr('href', urlChange).text(nameChange);
              selector.find('> .rebuy-cart__flyout-item-info .rebuy-money').text(priceChange);

          } else if ($(this).hasClass('product-teardrop-pendant') && $(this).hasClass('property-key-id-set')){

              var urlChange = 'https://mayamarjewelry.com/products/satin-teardrop-pendant';
              var nameChange = 'Satin Teardrop Pendant';
              var imagenChange = 'https://cdn.shopify.com/s/files/1/0053/8620/7281/files/BlackSatinCord_AmberTeardropPendant_240x240.jpg';


              if(GlobalCampaignActive){
                var priceChange = '$106.80';
              } else {
                var priceChange = '$178.00';
              }

              selector.find('> .rebuy-cart__flyout-item-media img').attr('src', imagenChange);
              selector.find('> .rebuy-cart__flyout-item-media a').attr('href', urlChange);
              selector.find('> .rebuy-cart__flyout-item-info > a').attr('href', urlChange).text(nameChange);
              selector.find('> .rebuy-cart__flyout-item-info .rebuy-money').text(priceChange);

          }

      });

      $('.container-set-rebuy--'+ id +' .info-products-set').append(productsList);
      $('.rebuy-cart__flyout-sets .container-set-rebuy--' + id +' .rebuy-price-container-set').text($priceSetShow);
      
    };

    cantidadElementos++;

  };
  
  if(cantidadElementos > 0){
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets').css('display','flex');
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets').hide();
  };

  if(lineItemsBasic > 0){
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-items').show();
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-items').hide();
  };


  if(cantidadElementos > 0 && lineItemsBasic > 0){
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets h4').show();
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .title-simple-products').show();
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets h4').hide();
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .title-simple-products').hide();
  };


};


$(document).on('click', '.container-set-rebuy button.rebuy-cart__flyout-item-remove', function () {
    var $selectorItem = ($(this).parents('.container-set-rebuy').find('> ul').attr('class')).toUpperCase();
    var $selectorProducts = $(this).parents('.container-set-rebuy').find('> ul').attr('class');
    console.log('Selector Products:', $selectorItem);

    var $removeSet = $('.rebuy-cart__flyout-sets .container-set-rebuy--' + $selectorProducts);
    $($removeSet).replaceWith('<div class="container-set-rebuy--' + $selectorProducts +' rebuy-cart__flyout-sets--deleted"><div class="load-more__spinner"></div><p>Remove set</p></div>');

    $.getJSON('/cart.js', function(cart) {
        console.log('Carrito obtenido:', cart);
        var updatesObj = {};

        var itemsToDelete = cart.items.filter(item => item.properties && item.properties['ID SET'] === $selectorItem);
        console.log('Items to Delete:', itemsToDelete);

        itemsToDelete.forEach(function(item) {
            updatesObj[item.key] = 0;
        });

        console.log('Updates Object:', updatesObj);

        if (Object.keys(updatesObj).length > 0) {
            $.post('/cart/update.js', {
                updates: updatesObj
            }, function(response) {
                console.log('Carrito actualizado:', response);
                $('.container-set-rebuy--' + $selectorProducts).remove();
            }).fail(function(error) {
                console.error('Error al actualizar el carrito', error);
            });
        }
    }).fail(function(error) {
        console.error('Error al obtener el carrito:', error);
    });
});


$(document).on('click', '.container-set-rebuy .container-button-view-all-products span.view-products.button-active', function (){
  $(this).parents('.container-set-rebuy').find('> ul').slideDown();
  $(this).text('Hide Products');
  $(this).removeClass('button-active');
  $(this).addClass('button-off');
});

$(document).on('click', '.container-set-rebuy .container-button-view-all-products span.view-products.button-off', function (){
  $(this).parents('.container-set-rebuy').find('> ul').slideUp();
  $(this).text('View Products');
  $(this).removeClass('button-off');
  $(this).addClass('button-active');
});